import React from "react";
import { Typography } from "@mui/material";
import { formatTime } from "components/audioPlayer/utils/formatTime";

const TimeDisplay = ({ time }) => {
  return <Typography sx={{ minWidth: 40 }}>{formatTime(time)}</Typography>;
};

export default TimeDisplay;
